import cookie from "react-cookies";
import {isEmpty} from "../../../helpers/helpers";
import {inArray} from "../../../helpers/arrays";
import {saveCookie} from "../../../../helpers/cookie";

function explodeMergedTypes(types) {
    let tmp = [];
    if (types.length) {
        for (let type of types) {
            if (type.indexOf('.') !== -1) {
                tmp = [...tmp, ...type.split('.')];
            } else {
                tmp.push(type);
            }
        }
    }

    return tmp;
}

const checkType = (types) => {
    const items = ['apartment', 'house', 'land'];
    let result = false;

    for (let type of types) {
        if (inArray(type, items)) {
            result = true;
        }
    }

    return result;
};

var investmentPopUpQueue = false;

export function checkRunInvestmentConversionsPopUp(params, callBack) {
    const checkCookie = cookie.load('show_investment_popup');

    if (isEmpty(checkCookie) && !investmentPopUpQueue) {
        const city_id = !isEmpty(params['city_id']) ? params['city_id'] : '';
        const deal_type = !isEmpty(params['deal_type']) ? params['deal_type'] : '';
        let types = (!isEmpty(params['types']) && params['types'].length) ? explodeMergedTypes(params['types']) : [];


        if (
            1 === 2 && // just dont show :)
            inArray(city_id, [207]) &&
            inArray(deal_type, ['sale']) &&
            checkType(types)
        ) {
            investmentPopUpQueue = true;

            setTimeout(() => {
                const checkCookie = cookie.load('show_investment_popup');
                const checkCity = cookie.load('default_city_id');

                if (isEmpty(checkCookie) && !isEmpty(checkCity) && Number(checkCity) === 207) {
                    saveCookie('show_investment_popup', true); // 30 day
                    callBack();
                }
            }, 6 * 60 * 1000) // 6 min
        }
    }
}